import { connect } from 'react-redux';
import TaskProgressList from '../../../components/home/TaskProgressList';
import {
  currentStore,
  loadingProgress,
  progressTasksTypeBaseline,
  resourcesTasksType,
} from 'core/selectors';

export default connect(
  state => ({
    loading: !currentStore(state) || loadingProgress(state),
    progress: progressTasksTypeBaseline(state),
    resources: resourcesTasksType(state),
  }),
  {},
)(TaskProgressList);
